package com.devi3east.bashbuddy.features.common.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.navigation.NavController
import com.devi3east.bashbuddy.auth.util.RecoveryTokenStore
import com.devi3east.bashbuddy.auth.util.parseRecoveryToken
import com.devi3east.bashbuddy.features.app.data.Screen

@Composable
fun DeepLinkListener(navController: NavController) {
    DisposableEffect(Unit) {
        ExternalUriHandler.listener = { uri ->

            // Password reset handling
            if (uri.contains("reset")) {
                val token = parseRecoveryToken(uri)
                if (token.isNotBlank()) {
                    RecoveryTokenStore.token = token
                }
                navController.navigate(Screen.ResetPasswordScreen.route) {
                    launchSingleTop = true
                }
            }
            // Stripe checkout success/cancel
            else if (uri.contains("stripe/success") || uri.contains("stripe/cancel")) {
                navController.navigate(Screen.CartScreen.route) {
                    launchSingleTop = true
                    restoreState = true
                }
            }
            // Default fallback
            else {
                navController.navigate(Screen.EventsScreen.route) {
                    launchSingleTop = true
                }
            }
        }

        onDispose {
            ExternalUriHandler.listener = null
        }
    }
}